<template>
  <div class="l-header">
    <div class="l-header-content">
      <div class="l-header-content-left">
        <div class="l-user-info">
          <div class="l-user-info-bg" @click="onToUserCenter">
            <img class="l-user-avatar" :src="user.headImg
              ? user.headImg
              : require('./images/head-img-small.png')
            " alt />
          </div>
          <div class="l-user-name">
            <div class="l-name">{{ user.nickName ? user.nickName : user.cnName }}</div>
            <div class="learning-stage">
              <div v-if="user.yuRank && user.yuRank.length > 0">{{ user.yuRank ? user.yuRank.join(",") : "" }}
              </div>
              <div v-if="user.yueRank && user.yueRank.length > 0">{{ user.yueRank ? user.yueRank.join(",") :
                "" }}</div>
              <!-- <img src="./images/explain.png" class="l-header-explain" @click="onShowDialog(1)" alt="" /> -->
            </div>
          </div>
        </div>
      </div>
      <div class="l-header-content-right">
        <LDiamondcrystal />
        <LCoin :lilyCoin="account.coin" />
      </div>
    </div>
  </div>
</template>

<script>
import clickOutside from '../../../directives/outside-click/index.js'
import LCoin from '@/components/l-coin'
import LDiamondcrystal from './components/l-diamond-crystal/index'
import UsercenterModel from '@/models/usercenter'
import AccountModel from '@/models/account'
const usercenterModel = new UsercenterModel()
const accountModel = new AccountModel()
export default {
  name: 'l-header',
  data () {
    return {
      visible: false, //header组件的弹框
      isShowMenu: false, //是否展示菜单
      modelType: 1, //弹框类型
      user: {}, //用户信息
      account: {
        coin: 0
      }, // 账户信息
      fullscreen: false, //全屏
      isShowFullscreenIcon: false, //全屏按钮是否展示
      diamondList: [],
    }
  },
  components: {
    LCoin,
    LDiamondcrystal,
  },

  directives: {
    clickOutside,
  },
  mounted () {
    this.getUserInfo()
  },
  methods: {
    //获取用户信息
    getUserInfo () {
      usercenterModel.getUser().then((res) => {
        this.user = res.data
      })
      accountModel.coin().then((res) => {
        this.account.coin = res.data ? res.data.real : 0
      })
      // usercenterModel.getJewelInfo().then((res) => {
      //   this.account = res.data.accountResp
      //   this.diamondList = res.data.diamondRespList
      // })
    },
    //退出菜单以外的点击事件
    onOutside () {
      this.isShowMenu = false
    },
    //改变图标
    onOpenMenu () {
      this.isShowMenu = !this.isShowMenu
    },
    //弹框展示
    onShowDialog () {
      this.$lPrompt({
        type: 'overall', // 使用这个弹框传递这个type字段并且使用overall类型,原本有的弹框使用逻辑不变
        title: '闯关段位规则', //title:标题
        message: (
          <div class="l-header-dialog-content">
            1.段位:
            <br />
            <div class="l-content-p">
              武功晋级路线：分为<span>4个大段位</span>，分别是：
              <span>新秀、少侠、大侠、掌门</span>,其中<span>新秀</span>有
              <span>2</span>个小段位，<span>少侠、大侠、掌门</span>各有
              <span>4</span>个小段位；
              <br />
            </div>
            <div class="l-content-p">
              文功晋级路线：分为<span>4个大段位</span>，分别是：
              <span>书童、秀才、举人、进士</span>,其中<span>书童</span>有
              <span>5</span>个小段位，<span>秀才</span>有<span>4</span>
              个小段位，<span>举人</span>有<span>2</span>个小段位，
              <span>进士</span>有<span>3</span>个小段位；
            </div>
            2.晋级:
            <br />
            <div class="l-content-p">
              当每个大段位的最后1个小段位的最后1关卡通关，则自动进阶下一段位；
            </div>
          </div>
        ),
      })
      // if (type == 5) {
      //   this.onLogout();
      // } else {
      //   LHeaderDialog({
      //     modelType: true,
      //     type: type,
      //   });
      // }
    },
    //退出登录
    onLogout () {
      usercenterModel
        .logout(this.user.id)
        .then(() => {
          localStorage.removeItem('questionEnd')
          localStorage.removeItem(window.$USERKEY)
          sessionStorage.removeItem('CLOSE_STATUS' + '_' + this.user.id)
          // window.location.href =
          //   window.location.protocol + "//" + window.location.host + "/login";
          // window.location.href = process.env.VUE_APP_BASE_URL + '/login'
          // window.$dayuan1997.login(encodeURIComponent(window.location.href))
          window.$dayuan1997.login(
            encodeURIComponent(
              window.location.protocol + '//' + window.location.host
            )
          )
        })
        .catch((error) => {
          this.$lPrompt({
            message: error.msg,
            successTxt: '确定',
          })
        })
    },
    onGoList () {
      this.$router.push({ path: '/' })
    },
    onToUserCenter () {
      this.$router.push({ path: '/user' })
    },
  },
}
</script>

<style lang="stylus" scoped>
@import './index.styl'
</style>
